import { CoinDto } from './order';
import { TeaserPointResponse } from './teaser';

export const defaultOdd: OddModel = {
  id: '',
  sportsBookName: '',
  name: '',
  price: 0,
  decimalPrice: 0,
  timestamp: null,
  betPoints: 0,
  main: false,
  live: false,
  marketName: '',
  market: '',
  selection: '',
  normalizedSelection: '',
  selectionLine: '',
  selectionPoints: 0,
  status: '',
};

export interface SingleBet {
  oddsId: string;
  amount: number;
}

export interface ComboBet {
  oddsId: string;
}

export interface PlacingComboBetRequestBody {
  amount: number;
  bets: PlacingComboBet[];
}

export interface PlacingBetsRequestBody {
  bets: PlacingBet[];
}

export interface PlacingBet {
  gameId?: string;
  oddsId: string;
  amount: number;
  futureId?: string;
  market?: string;
}

export interface PlacingComboBet {
  oddsId: string;
  gameId?: string;
  futureId?: string;
  market?: string;
}

export interface AdditionScoreInfo {
  Balls: number;
  Strikes: number;
  TotalPitches: number;
}

export interface ScoreModel {
  id: string;
  scoreHomeTotal: number;
  scoreAwayTotal: number;
  clock: string;
  period: string | null;
  status: string;
  live: boolean;
  duration: any;
  startDate: string;
  homeTeam: string;
  awayTeam: string;
  venueName: string;
  additionalInfo: string;
}

export interface SportModel {
  key: string;
  group: string;
  title: string;
  description: string;
}

export interface OddModel {
  id: string;
  sportsBookName: string;
  name: string;
  price: number;
  decimalPrice: number;
  timestamp: null;
  betPoints: number | null;
  main: boolean;
  live: boolean;
  marketName: string;
  market: string;
  selection: string;
  normalizedSelection: string;
  selectionLine: string | null;
  selectionPoints: number | null;
  status: string;
}

export interface GameResponseModel {
  id: string;
  startDate: string;
  homeTeam: string;
  homeTeamLogo: string;
  awayTeam: string;
  awayTeamLogo: string;
  status: string;
  score: ScoreModel;
  odds: OddModel[];
  sport: SportModel;
  alternativeOdds: OddModel[];
  propsOdds: OddModel[];
  gameProps: OddModel[];
  amountUserBetGame: number;
  homeTeamInjuries: TeamInjuries[];
  awayTeamInjuries: TeamInjuries[];
  awayStarter: string;
  homeStarter: string;
  isPinned: boolean;
  commentCounter: number;
  isLiked: boolean;
  likedCounter: number;
  dislikedCounter: number;
  isDisliked: boolean;
  oddsMap?: Map<string, OddModel[]>;
}

export interface UserModel {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
}

export interface MarketModel {
  id: string;
  sportsBookName: string;
  name: string;
  price: number;
  decimalPrice: number;
  timestamp: number;
  betPoints: number;
  main: boolean;
  live: boolean;
  marketName: string;
  market: string;
  selection: string;
  normalizedSelection: string | null;
  selectionLine: string;
  selectionPoints: number;
  status: string;
}

export interface BetDetailModel {
  id: number;
  winPrice: number;
  odds: OddModel;
  status: string;
  calculatedAt: string;
  game: GameResponseModel;
  market: MarketModel;
  future: FutureInfoResponseModel;
  futureOdds: FutureOddModel;
  futureMarket: FutureOddModel;
  type: string;
  homeScore: number;
  awayScore: number;
}

export interface BetResponseModel {
  id: number;
  amount: number;
  winAmount: number;
  type: string;
  status: string;
  calculatedAt: string;
  createdDate: string;
  user: UserModel;
  betDetails: BetDetailModel[];
  coin: CoinDto;
  teaserPoint: TeaserPointResponse;
}

export interface DashboardResponseModel {
  newGames: CasinoGameResponseModel[];
  liveCasinoGames: CasinoGameResponseModel[];
  videoSlotsGames: CasinoGameResponseModel[];
  tableGames: CasinoGameResponseModel[];
  crashGames: CasinoGameResponseModel[];
  scratchCardsGames: CasinoGameResponseModel[];
}

export interface CasinoGameResponseModel {
  id: string;
  name: string;
  type: string;
  subcategory: string;
  details: string;
  isNew: string;
  system: string;
  position: string;
  category: string;
  licence: string;
  plays: number;
  rtp: string;
  wagering: any;
  gamename: string;
  report: string;
  mobile: boolean;
  releaseDate: string | null;
  additional: AdditionalModel;
  idHash: string;
  idParent: string;
  idHashParent: string;
  freeroundsSupported: boolean;
  featurebuySupported: boolean;
  hasJackpot: boolean;
  provider: string;
  providerName: string;
  playForFunSupported: boolean;
  image: string;
  imagePreview: string;
  imageFilled: string;
  imagePortrait: string;
  imageSquare: string;
  imageBackground: string;
  imageBw: string;
}

export interface AdditionalModel {
  width: string;
  height: string;
  stretching: boolean;
  html5: boolean;
  volatility: string;
  megaways: boolean;
  bonusbuy: boolean;
  aspect_ratio: string;
  scale_up: boolean;
  scale_down: boolean;
  max_exposure: string;
  jackpot_type: string;
}

export interface PlayGameResponseModel {
  url: 'string';
  game: CasinoGameResponseModel;
}

export interface ShareBetResponseModel {
  userId: number;
  id: number;
  status: string;
  username: string;
  winAmount: number;
  amount: number;
  type: string;
  betDetails: ShareBetDetailModel[];
  teaserPoint: TeaserPointResponse;
}

export interface GiveAwayModel {
  promotionCode: string;
  amount: string;
  quantity: number;
  coinSymbol: string;
  walletReceive: string | null;
}

export interface ShareBetDetailModel {
  id: number;
  winPrice: number;
  status: string;
  market: MarketModel;
  homeTeam: string;
  awayTeam: string;
  futureOdd: FutureOddModel;
  league: string;
  type: string;
}

export interface CopyBetRequestBody {
  betId: number;
  amount: number;
}

export interface ShareBetRequestBody {
  betId: number;
}

export interface FutureInfoResponseModel {
  id: string;
  name: string;
  sport: string;
  league: string;
}

export interface FutureResponseModel {
  id: string;
  name: string;
  sport: string;
  league: string;
  futureOdds: FutureOddModel[];
  amountUserBetFuture: number;
}
export interface FutureOddModel {
  id: string;
  sportBookName: string;
  name: string;
  price: number;
  decimalPrice: number;
  timestamp: string;
  betPoints: number;
  main: boolean;
  selection: string;
  normalizedSelection: string;
  selectionLine: string;
  selectionPoints: number;
  status: string;
  teamLogo: string;
}

export interface PlayerModel {
  id: string;
  playerName: string;
  firstName: string;
  lastName: string;
  number: string;
  logo: string;
}

export interface TeamInjuries {
  id: string;
  player: PlayerModel;
  injuryStatus: string;
  injuryType: string;
  position: string;
}

export interface BetVoiceResponseModel {
  games: GameResponseModel[];
  amount: number;
  odds: OddModel;
}

export interface BetVoiceRequestBody {
  message: string;
  gameId?: string | null;
}

export interface PnLResponse {
  winAmount: string;
  loseAmount: string;
  pnl: string;
}

export interface OddsRequest {
  gameIds: string;
}

export interface OddsResponse {
  gameOdds: OddModel[];
  gameId: string;
}

export interface OddsMessage {
  odds: OddModel[];
  gameId: string;
  gameMarket: string;
  type: string;
  matchTime: string;
}

export interface MatchTimeResponse {
  fixtureId: string;
  currentPhase: string;
  timeStampUtc: string;
  timeRemainingInPhaseMilliseconds: string;
  isClockRunning: boolean;
  isMatchFinished: boolean;
}
